import { ElementType } from './element-type';

export type FormElementDefinition = {
  formElementDefinitionId: string;
  formElementType: ElementType;
  formId: string;
  name: string;
};

export enum FormElementTypeEnum {
  divider = 'divider',
  multi_select = 'multi_select',
  page = 'page',
  review_page = 'review_page',
  scale = 'scale',
  short_answer = 'short_answer',
  simple_input = 'simple_input',
  single_select = 'single_select',
}
